/** 动态调整 id 列宽 */
export const getSelectionWidth = (total: number) => {
  const len = total.toString().length;
  // 数据与宽度
  // 数据长度大于 4，每一位增加 10 px
  return Math.max(50, 20 + len * 10).toString();
}
